import React, { useEffect } from 'react'
import logoutQueryString from 'src/utils/logoutQueryString'
import Footer from 'src/components/Footer/Footer'
import Navbar from 'src/components/Navbar/Navbar'
import ProjectsContent from 'src/components/ProjectsContent/ProjectsContent'

const ProjectsPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    logoutQueryString()
  }, [])

  return (
    <>
      <Navbar />
      <ProjectsContent />
      <Footer />
    </>
  )
}

export default ProjectsPage
